<script setup lang="ts">
import { EventBus, Event } from "@/services/eventBus";
import { onMounted, onUnmounted } from "vue";

const msg = ref("");
const cssClass = ref("");

onMounted(() => {
  EventBus.on(Event.ShowTextOverlay, show);
  EventBus.on(Event.HideTextOverlay, hide);
});
onUnmounted(() => {
  EventBus.off(Event.ShowTextOverlay, show);
  EventBus.off(Event.HideTextOverlay, hide);
});

const show = (msgText: string) => {
  msg.value = msgText;
  cssClass.value = "overlay-message--visible";
};
const hide = () => {
  cssClass.value = "overlay-message--hiding";
  setTimeout(() => {
    cssClass.value = "";
  }, 500);
};
</script>

<template>
  <div :class="['overlay-message', cssClass]">
    <div class="overlay-message__text">
      {{ msg }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overlay-message {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(#000, 0.9);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
  opacity: 0;
  display: none;
  transition: opacity 0.3s ease;
  &--visible {
    opacity: 1;
    display: flex;
    z-index: 9999;
  }
  &--hiding {
    display: flex;
    opacity: 0;
  }
  &__text {
    color: #fff;
    font-size: 25px;
    font-weight: 400;
    width: 90%;
    max-width: 500px;
    text-align: center;
  }
}
</style>
